// webpack inserts code here
window.buildData = "ver3-573-0-backoffice-frontend-2026-08-25_14-29-18.f5beb402";

const config = (window as any).env || {};
export const SERVER_URL: string = process.env.REACT_APP_SERVER_URL || config.SERVER_URL || '';
export const GAME_HISTORY_URL: string = config.GAME_HISTORY_URL || '';
export const IS_PROD: boolean = Boolean(config.IS_PROD);
export const IS_KOALA: number = config.IS_KOALA || 0;
export const DISABLE_MANUAL_RESOLVE_GAME_TYPES: string[] =
    config.DISABLE_MANUAL_RESOLVE_GAME_TYPES ?? [];
export const CONSTANTS: any = {
    message_duration: 5, // in seconds
    game_history_languages: [
        'bg',
        'cs',
        'da',
        'de',
        'el',
        'en',
        'es',
        'et',
        'fi',
        'fr',
        'hr',
        'hu',
        'id',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'pt-br',
        'ro',
        'ru',
        'sk',
        'sv',
        'th',
        'tr',
        'vi',
        'zh',
    ],
    dateFormat: 'DD/MM/YYYY',
    dateFormatWithTime: 'HH:mm:ss - DD/MM/YYYY',
};
